import type { ReactNode } from 'react'
import { useTimezone } from 'src/modules/core/hooks/use-timezone'
import { DisplayTimezoneContext } from './display-timezone-context'

export function DisplayTimezoneProvider({ children }: { children: ReactNode }) {
  const value = useTimezone()
  return <DisplayTimezoneContext.Provider value={value}>{children}</DisplayTimezoneContext.Provider>
}
